<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价出价记录.询价活动名称')" prop="userId">
                <a-input v-model="queryParam.activityName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.询价活动名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价出价记录.商品名称')" prop="userId">
                <a-input v-model="queryParam.goodsName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('询价出价记录.商品名称')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价出价记录.交付时间')" prop="deliverDate">
                <a-date-picker style="width: 100%" v-model="queryParam.deliverDate" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['activityChujia:activityChujia:add']">-->
<!--          <a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['activityChujia:activityChujia:edit']">-->
<!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['activityChujia:activityChujia:remove']">-->
<!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['activityChujia:activityChujia:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 增加详情 -->
      <mybid-detail
        ref="mybidDetail"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
         <span slot="bidStatus" slot-scope="text, record">
           <span v-if="record.bidStatus == '10'">
             待开标
           </span>
           <span v-if="record.bidStatus == '20'">
            已中标
           </span>
           <span v-if="record.bidStatus == '30'">
            未中标
           </span>
         </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="deliverDate" slot-scope="text, record">
          {{ parseTime(record.deliverDate) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['activityChujia:activityChujia:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['activityChujia:activityChujia:edit']">-->
<!--             <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--          </a>-->
<!--          <a-divider type="vertical" v-hasPermi="['activityChujia:activityChujia:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['activityChujia:activityChujia:remove']">-->
<!--            <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--          </a>-->
           <a @click="$refs.mybidDetail.handleUpdate(record, undefined)">
            <a-icon type="view" />详情
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageActivityChujia,listActivityChujia, delActivityChujia,mybidpage,myplatbidpage } from '@/api/activityChujia/activityChujia'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import MybidDetail from './modules/MybidDetail'
import XunjiaDetail from "@/views/activityXunjia/activityXunjia/modules/XunjiaDetail.vue";
export default {
  name: 'ActivityChujia',
  components: {
    XunjiaDetail,
    CustomDictTag,
    CreateForm,
    MybidDetail
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        activityId: undefined,
        activityName: undefined,
        goodsName: undefined,
        goodsId: undefined,
        sort: undefined,
        payBond: undefined,
        bondMoney: undefined,
        payMethod: undefined,
        payType: undefined,
        payStatus: undefined,
        endMoney: undefined,
        quoMoney: undefined,
        deliverDate: undefined,
        bidStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('询价出价记录.id'),
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.出价用户id'),
        //   dataIndex: 'userId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.询价活动ID'),
        //   dataIndex: 'activityId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.询价商品ID'),
        //   dataIndex: 'goodsId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.排序'),
        //   dataIndex: 'sort',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.创建时间'),
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.备注'),
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.是否需要缴纳保证金 0:否 1:是'),
        //   dataIndex: 'payBond',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.保证金金额'),
        //   dataIndex: 'bondMoney',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.支付方式 1:支付宝 2:微信'),
        //   dataIndex: 'payMethod',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.付款方式 10:现金支付 20:线上转账'),
        //   dataIndex: 'payType',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价出价记录.支付状态 10:未支付 20:支付成功'),
        //   dataIndex: 'payStatus',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('询价出价记录.询价活动名称'),
          dataIndex: 'activityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价出价记录.商品名称'),
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价出价记录.底价'),
          dataIndex: 'endMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价出价记录.报价金额'),
          dataIndex: 'quoMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价出价记录.交付时间'),
          dataIndex: 'deliverDate',
          scopedSlots: { customRender: 'deliverDate' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价出价记录.中标状态'),
          dataIndex: 'bidStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'bidStatus' },
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询询价出价记录列表 */
    getList () {
      this.loading = true
      myplatbidpage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        activityId: undefined,
        goodsId: undefined,
        sort: undefined,
        payBond: undefined,
        bondMoney: undefined,
        payMethod: undefined,
        payType: undefined,
        payStatus: undefined,
        endMoney: undefined,
        quoMoney: undefined,
        deliverDate: undefined,
        bidStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delActivityChujia(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('activityChujia/activityChujia/export',
            ...that.queryParam
          , `询价出价记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
